import { render, staticRenderFns } from "./EditComplexLookupComponent.vue?vue&type=template&id=23d3042c&scoped=true&"
import script from "./EditComplexLookupComponent.vue?vue&type=script&lang=js&"
export * from "./EditComplexLookupComponent.vue?vue&type=script&lang=js&"
import style0 from "./EditComplexLookupComponent.vue?vue&type=style&index=0&id=23d3042c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d3042c",
  null
  
)

export default component.exports